import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../../../common/dropdown'
import { Element } from '../../../../../common/html/element'
import { SelectCustom } from '../../../../../common/selectCustom'
import { Z_INDEX } from '../../../../../utils/common'
import { ItemHover } from '../../../common/html/ItemHover'
import { TYPE_SELECT_TREND_SCORE } from '../../../constant'
import { changeDataCellTable } from '../../store/slice'
import { Trend } from './Trend'

export const TrendSelect = ({ data, rowId, colId }) => {
  const dispatch = useDispatch()

  const handleChoose = (item) => {
    dispatch(
      changeDataCellTable({
        rowId,
        colId,
        data: item.value,
      }),
    )
  }

  return (
    <SelectCustom
      renderActiveItem={() => <Trend data={data} />}
      activeItem={{ label: data, value: data }}
      data={TYPE_SELECT_TREND_SCORE}
      zIndex={Z_INDEX.MODAL + 1}
      iconNoPosition
      style={{
        borderColor: 'transparent',
      }}
      chooseItem={handleChoose}
      dropdownPosition={positionDropdown.BOTTOM_START_RIGHT}
      renderDropdownItem={(item, onClickItem) => (
        <ItemHover
          className="dFlex alignItemsCenter cursorPointer gap1"
          onClick={() => onClickItem(item)}
          style={{ padding: '4px 12px' }}
        >
          <Trend data={item.value} />
          <Element
            style={{ color: data === item.value ? '#0553A5' : '#3A414B' }}
            className={data === item.value ? 'fw600' : ''}
          >
            <Translate value={`portfolioScore.${item.value}`} />
          </Element>
        </ItemHover>
      )}
    />
  )
}
